import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';

function cleanup(instance) {
  instance.count = 0;
}

export default class onUpdateModifier extends Modifier {
  count;
  // The constructor allows you to initialize any properties
  constructor(element, args) {
    super(element, args);
    registerDestructor(this, cleanup);
    this.count = 0;
  }

  // The modify method is called to apply the logic to the element
  modify(element, [callback, ...args], named) {
    if (!element) {
      return;
    }
    this.count = this.count + 1;
    if (this.count === 1) return;
    if (typeof callback === 'function') {
      callback(element, ...args, { ...named });
    }
  }
}
